const routes = {
  home: '/',
  people: '/people',
  person: '/person/:id',
  notFound: '*',
  favorites: '/favorites',
  search: '/search',
}

export default routes;